//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdAvatar from '../../common/elemental/AfitdAvatar';
import AfitdButtonGroup from '../../common/elemental/AfitdButtonGroup';
import AfitdButton from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: { padding: '0px 15px 15px 15px' },
        companyLogo: { marginRight: 16, borderRadius: '50%' },
        inviterProfilePic: { marginRight: 16 },
        content: { display: 'flex', alignItems: 'center', padding: '15px 0px' },
        acceptDeclineButtonGroup: { padding: '12px 0px' },
        buttonsContainer: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', background: 'rgba(0, 0, 0, 0.04)', borderRadius: 5 },
        inviterYouText: { color: 'rgba(17, 30, 20, 0.4)' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props, isSavedView, handleClickAcceptButton, handleClickDeclineButton } = params;
    const { data } = props;

    const companyProfilePicUrl = _get(data, 'companyProfilePicUrl');
    const companyName = _get(data, 'companyName');
    const inviterProfilePicUrl = _get(data, 'inviterProfilePicUrl');
    const inviterName = _get(data, 'inviterName');

    const defns = {
        companyLogo: {
            variant: 'rounded',
            src: companyProfilePicUrl,
        },
        companyName: { variant: 'body1', value: companyName },
        inviterProfilePic: {
            src: inviterProfilePicUrl,
        },
        inviterYouText: { variant: 'body1', component: 'span', value: ' (invited you)' },
        inviterName: { variant: 'body1', value: inviterName },
        acceptButton: { color: isSavedView ? 'secondary' : '', onClick: handleClickAcceptButton },
        declineButton: { color: isSavedView ? '' : 'secondary', onClick: handleClickDeclineButton },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const EmployerInviteItem = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);
    const [isSavedView, setIsSavedView] = useState(true);
    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    const handleClickAcceptButton = () => {
        setIsSavedView(true);
    };
    const handleClickDeclineButton = () => {
        setIsSavedView(false);
    };
    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, isSavedView, handleClickAcceptButton, handleClickDeclineButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div>
                <div {...defns.content}>
                    <AfitdAvatar {...defns.companyLogo} />
                    <AfitdTypography {...defns.companyName} />
                </div>
                <div>
                    <Divider />
                </div>
                <div {...defns.content}>
                    <AfitdAvatar {...defns.inviterProfilePic} />
                    <AfitdTypography {...defns.inviterName} />
                    <span>&nbsp;</span>
                    <AfitdTypography {...defns.inviterYouText} />
                </div>
            </div>
            <div {...defns.buttonsContainer}>
                <AfitdButtonGroup variant="contained" aria-label="contained button group" {...defns.acceptDeclineButtonGroup}>
                    <AfitdButton isGroup={true} {...defns.acceptButton}>
                        Accept
                    </AfitdButton>
                    <AfitdButton isGroup={true} {...defns.declineButton}>
                        Decline
                    </AfitdButton>
                </AfitdButtonGroup>
            </div>
        </div>
    );
};

export default EmployerInviteItem;
